import React, { ReactElement, useState, useEffect } from "react";
import styles from "./SmartValidation.module.css";

const tick = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="5" cy="5" r="5" fill="#7DC554"/><path d="M4 6.40003L2.6 5.00003L2.13333 5.4667L4 7.33337L8 3.33337L7.53333 2.8667L4 6.40003Z" fill="white"/></svg>`;
const bullet = `<svg width="10" height="10" viewBox="0 0 10 10" fill="none" xmlns="http://www.w3.org/2000/svg"><circle cx="5" cy="5" r="4.5" stroke="#252525"/></svg>`;

interface SmartValidationProps {
  value:string,
  rules:Rule[]
}

interface Rule {
  valid:boolean,
  pattern:RegExp,
  label:string
}

const SmartValidation: React.FC<SmartValidationProps> = (props): ReactElement => {
  const [rules, setRules] = useState([] as Rule[]);
  const [readyToValidate, setReadyToValidate] = useState(false);

  const validateRules = () => {
    if(rules.length > 0){
      let validationRules = [...rules];
      validationRules.map((rule:any) => {
        rule.valid = props.value ? rule.pattern.test(props.value) : false;
      });
      setRules(validationRules);
    }
  }

  useEffect(() => {
    setRules(props.rules);
  },[]);

  useEffect(()=>{
    setReadyToValidate(true);
  }, [rules]);

  useEffect(validateRules,[props.value, readyToValidate]);

  return (
    <ul className={styles.rulesList}>
      {rules.map((rule:any, i:number) => {
        return <li key={`rule-${i}`}>
                  {rule.valid && <img src={`data:image/svg+xml;utf8,${encodeURIComponent(tick)}`} className={styles.tick} alt="Ticked"/> }
                  {!rule.valid && <img src={`data:image/svg+xml;utf8,${encodeURIComponent(bullet)}`} className={styles.bullet} alt="Not Ticked"/> }
                  {rule.label}
                </li>
      })}
    </ul>
  );
};

export default SmartValidation;
